import { logWrapper } from '../../utils';

export default {
  signDocumentService: [
    'runtimeConstant',
    '$http',
    '$q',
    'webApiSettings',
    '$filter',
    function (runtimeConstant, $http, $q, webApiSettings, $filter) {
      'use strict';

      function handleError(status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SIGNING DOCUMENT'),
        };
      }

      function getHashes(docsInfos) {
        var deferred = $q.defer();

        var flowDocs = docsInfos.filter(
          (d) =>
            d.inFlow !== undefined && d.inFlow !== null && d.inFlow !== false
        );
        var docs = docsInfos.filter(
          (d) =>
            d.inFlow === undefined || d.inFlow === null || d.inFlow === false
        );
        var docsHashes = null;
        var flowDocsHashes = null;

        var hashes = null;

        if (docs.length > 0) {
          $http
            .post(webApiSettings.apiServiceBaseUri + 'signer/hash', docs, {
              ignoreLoadingBar: true,
            })
            .then(function (res) {
              docsHashes = res.data;

              if (flowDocsHashes !== null && hashes === null) {
                hashes = docsHashes.concat(flowDocsHashes);
                deferred.resolve(hashes);
              }
            })
            .catch(function (err) {
              var error = handleError(err.status);
              deferred.reject(error);
            });
        } else {
          docsHashes = [];
        }

        if (flowDocs.length > 0) {
          $http
            .post(
              webApiSettings.apiServiceBaseUri + 'signer/hash/inflow',
              flowDocs,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(function (res) {
              flowDocsHashes = res.data;

              if (docsHashes !== null && hashes === null) {
                hashes = docsHashes.concat(flowDocsHashes);
                deferred.resolve(hashes);
              }
            })
            .catch(function (err) {
              var error = handleError(err.status);
              deferred.reject(error);
            });
        } else {
          flowDocsHashes = [];
        }

        return deferred.promise;
      }

      function finalizeSignature(docInfo) {
        var deferred = $q.defer();

        var url =
          docInfo.inFlow !== undefined &&
          docInfo.inFlow !== null &&
          docInfo.inFlow !== false
            ? 'signer/finalize/inflow'
            : 'signer/finalize';

        $http
          .post(webApiSettings.apiServiceBaseUri + url, docInfo, {
            ignoreLoadingBar: true,
          })
          .then(function (result) {
            deferred.resolve(result.data);
          })
          .catch(function (err) {
            deferred.reject(handleError(err.status));
          });

        return deferred.promise;
      }

      function run() {
        try {
          var signDocumentFactory = {};

          signDocumentFactory.getHashes = logWrapper(
            getHashes,
            runtimeConstant.isDebugServicesInternals
          );
          signDocumentFactory.finalizeSignature = logWrapper(
            finalizeSignature,
            runtimeConstant.isDebugServicesInternals
          );

          return signDocumentFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
